<template>
  <section>
    <div
      class="admin grid-content bg-purple-dark"
      v-if="!$store.getters['isAdmin']"
    >
      <el-alert type="error">
        <h2>No access to the Admin</h2>
      </el-alert>
    </div>
    <div class="admin" v-else>
      <ElHeader>
        <div>
          <table border="0" width="100%">
            <tr>
              <td width="80%">
                <span style="font-size: 2em; font-weight:bold"
                  >Historiana Admin</span
                >
              </td>
              <td align="right">
                <span class="logininfo">
                  <strong>{{ displayname }}</strong>
                  <br />
                  {{ now }}
                </span>
              </td>
              <td align="right">
                <el-button size="small"
                  >Logout <i class="far fa-sign-out"
                /></el-button>
              </td>
            </tr>
          </table>
        </div>
      </ElHeader>
      <ElContainer>
        <ElAside id="sidemenu" style="width: 200px">
          <ElMenu default-active="dashboard" :router="true">
            <ElMenuItem v-for="r in menuEntries" :index="r.name" :key="r.name">
              <RouterLink class="menu-entry" :to="{ name: r.name }">{{
                r.plural ? r.plural : r.name
              }}</RouterLink>
            </ElMenuItem>
          </ElMenu>
        </ElAside>
        <ElMain>
          <Transition name="fade">
            <RouterView />
          </Transition>
        </ElMain>
      </ElContainer>

      <ElFooter>
        <!--empty footer-->
      </ElFooter>
    </div>
  </section>
</template>

<script>
import tic from "../tic"
// import { API } from "../tic";
// import importCollection from 'views/admin/Collections'
import router from "../router"
import format from "date-fns/format"

// import {meta} from './meta.js'
import "../admin.scss"
import { mapState, mapActions, mapGetters, mapMutations } from "vuex"

export default {
  name: "Admin",
  methods: {
    ts(timestamp) {
      return tic.theDate(timestamp)
    },
    hd(timestamp) {
      return tic.humanDate(timestamp)
    },
  },

  computed: {
    ...mapGetters(["displayname", "isAdmin"]),

    now() {
      return format(new Date(), "d LLLL Y")
    },
  },

  beforeCreate() {
    console.log("ADMIN beforeCreate *****")
    // load meta data for various tags
    return this.$store.dispatch("init")
  },

  mounted() {
    console.log("my routes: ", router.options.routes)
    console.log("forms: ", this.$store.state.forms)

    const r = router.options.routes.filter((e) => {
      return e.name === "home"
    })[0].children

    console.log("r: ", r)

    console.log("bla: ", window.localStorage.session)
    this.$API.get("/").then((r) => {
      console.log("response: ", r.data)
    })

    // let me = this
    // document.location.hash === '#/s3cret?yay=1' ? me.sp = true : me.sp = false

    // get all meta info on stuff for UI elements
    // this.$API.get("/admin/meta", {}).then((resp) => {
    //   this.meta = resp.data.data
    // })
  },

  data() {
    return {
      menuEntries: router.options.routes.filter((e) => {
        return e.name === "home"
      })[0].children,
      data: [],
      meta: {},
    }
  },
}
</script>

<style>
th {
  text-align: left;
  color: white;
}
td,
th {
  padding: 0.2em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
span.admin {
  font-family: "Ubuntu";
  font-weight: 700;
  font-size: 2.4em;
}

.logininfo {
  font-family: "Ubuntu";
  font-weight: 500;
  float: right;
  text-align: right;
}

.login {
  display: flex;
  justify-content: center;
}
</style>
